import { useCallback, useState } from 'react';
import { mindtimeWazuhEndpointsApi } from 'src/api/mindtime/wazuhEndpointsApi';
import type { WazuhScopeParams } from 'src/types/mindtime/wazuhDashboard';
import type { WazuhEndpointItem } from 'src/types/mindtime/wazuhEndpoints';
import logger from 'src/utils/logger';
import type { SecuritySearchableFilterOption } from './SecuritySearchableFilter';

const resolveEndpointId = (item: WazuhEndpointItem): string =>
  String(item.wazuhAgentId ?? item.agentId ?? item.id ?? '');

const resolveEndpointLabel = (item: WazuhEndpointItem): string =>
  String(item.endpoint ?? item.agentName ?? item.name ?? resolveEndpointId(item));

export const useWazuhEndpointFilterOptions = (listScope: WazuhScopeParams) => {
  const [options, setOptions] = useState<SecuritySearchableFilterOption[]>([]);
  const [loading, setLoading] = useState(false);

  const onSearch = useCallback(
    async (query: string) => {
      setLoading(true);
      try {
        const result = await mindtimeWazuhEndpointsApi.list({
          ...listScope,
          search: query.trim() || undefined,
          page: 0,
          pageSize: 25,
        });
        setOptions(
          result.items
            .map((item) => ({
              value: resolveEndpointId(item),
              label: resolveEndpointLabel(item),
            }))
            .filter((option) => option.value)
        );
      } catch (error) {
        logger(error, 'error', 'useWazuhEndpointFilterOptions');
        setOptions([]);
      } finally {
        setLoading(false);
      }
    },
    [listScope]
  );

  return { options, loading, onSearch };
};
